var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-information',{attrs:{"title":_vm.title}},[_c('iframe',{staticStyle:{"border":"0","width":"100%"},attrs:{"height":"417","frameborder":"0","src":_vm.url,"allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }